import { ENV } from "../../Utils/constants";
import { cabecerasApi } from "./cabeceras";

export class DashboardProgressionApi {
  constructor() {
    this.baseApi = ENV.BASE_API; // .../api/v1
  }

  async getEvaluationSummary(token, patientId, { timeRange } = {}) {
    const base = `${this.baseApi}/revi/dashboard/patient/${patientId}/evaluation-summary`;
    const params = new URLSearchParams();
    if (timeRange && timeRange !== "all") {
      params.append("timeRange", timeRange);
    }
    const url = params.toString() ? `${base}?${params}` : base;

    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await response.json();
    if (response.status !== 200)
      throw new Error(
        json?.message || "Error cargando resumen de evaluaciones",
      );
    return json;
  }

  async getPatientHistory(
    token,
    patientId,
    { evaluationId, timeRange, sort, page, limit } = {},
  ) {
    const base = `${this.baseApi}/revi/dashboard/patient/${patientId}/history`;
    const params = new URLSearchParams();
    if (evaluationId) params.append("evaluationId", evaluationId);
    if (timeRange && timeRange !== "all") params.append("timeRange", timeRange);
    if (sort) params.append("sort", sort);
    if (page) params.append("page", String(page));
    if (limit) params.append("limit", String(limit));
    const url = params.toString() ? `${base}?${params}` : base;

    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await response.json();
    if (response.status !== 200)
      throw new Error(json?.message || "Error cargando historial");
    return json;
  }

  async getLatestEvaluationResult(token, patientId, evaluationId) {
    const url = `${this.baseApi}/revi/dashboard/patient/${patientId}/evaluation/${evaluationId}/latest`;

    const response = await fetch(url, {
      headers: cabecerasApi(token),
    });

    const json = await response.json();
    if (response.status === 404) return null;
    if (response.status !== 200)
      throw new Error(json?.message || "Error cargando ultimo resultado");
    return json;
  }
}
